const { isEmpty, inRange, range, } = require('lodash');
const { format: formatDate, } = require('date-fns');

const { optionLabel, } = require('../lib/consolidationAccountItems');
const { fiscalYearOfPeriod, periodOfFiscalYear, } = require('../util');

const { entries } = Object;

const inheritTypes = {
  none: { label: 'なし', },
  carry: { label: '繰越', },
  reversal: { label: '洗替', },
};

const roundingMethods = {
  round: { label: '四捨五入', },
  floor: { label: '切り捨て', },
  ceil: { label: '切り上げ', },
};

const fields = ({ company, companies = [], consolidationSegments = [], consolidationAccountItems = [], allConsolidationJournalTypes = [], customChangeFields = [], ordersByModelType = {}, keptChangeTypes = [], }) => {
  const { buildChangeTypeOptions, } = require('../changeTypes');
  const changeTypeOptions = buildChangeTypeOptions(customChangeFields, ordersByModelType, keptChangeTypes);
  const monthOptions = (periodFieldName) => (values) => {
    const fiscalYear = fiscalYearOfPeriod(values[periodFieldName], company.fiscalYears);
    return fiscalYear?.start_date ? [
      { label: '未選択', value: null },
      ...range(formatDate(new Date(fiscalYear.start_date), 'yyyyMM'), formatDate(new Date(fiscalYear.end_date), 'yyyyMM') + '.1').filter(_ => inRange(parseInt(_.toString().slice(-2), 10), 1, 12.1)).map(_ => ({ label: `${_.toString().slice(0, 4)}/${_.toString().slice(4)}`, value: _.toString() })),
    ] : [];
  };

  return {
    name: {
      label: '名称',
      type: 'string',
      validations: {
        required: v => !isEmpty(v),
      },
    },
    baseAmount: {
      label: '基礎金額',
      type: 'integer',
      validations: {
        required: v => v != null,
      },
    },
    ratio: {
      label: '対象割合',
      type: 'float',
      hint: '小数点以下第6位まで（例：0.123456）',
      validations: {
        required: v => v != null,
        range: v => v >= 0 && v <= 1,
      },
    },
    startPeriod: {
      label: '開始年度',
      type: 'select',
      options: (company.fiscalYears || []).map(_ => ({ label: `${_.start_date.replace(/-/g, '/').slice(0, 7)} - ${_.end_date.replace(/-/g, '/').slice(0, 7)}`, value: periodOfFiscalYear(_), })),
      validations: {
        required: v => v != null,
      },
    },
    startYearMonth: {
      label: '開始年月',
      type: 'select',
      options: monthOptions('startPeriod'),
      hidden: _ => _.startPeriod == null,
      validations: {
        required: v => v != null,
      },
    },
    months: {
      label: '期間（月数）',
      type: 'integer',
      validations: {
        required: v => v != null && v > 0,
      },
    },
    type: {
      label: '仕訳種別',
      type: 'select',
      options: allConsolidationJournalTypes.map(_ => ({ label: _.name, value: _.id })),
      validations: {
        required: v => v != null,
      },
    },
    inheritType: {
      label: '翌期への引き継ぎ',
      type: 'select',
      options: entries(inheritTypes).map(([k, v]) => ({ label: v.label, value: k })),
      initialValue: 'none',
    },
    roundingMethod: {
      label: '端数処理',
      type: 'select',
      options: entries(roundingMethods).map(([k, v]) => ({ label: v.label, value: k })),
      initialValue: 'round',
    },
    debitCompanyId: {
      label: '借方会社',
      type: 'select',
      options: companies.map(_ => ({ label: _.display_name, value: _.id })),
      validations: {
        required: v => v != null,
      },
    },
    debitItemId: {
      label: '借方科目',
      type: 'select',
      options: consolidationAccountItems.map(_ => ({ label: optionLabel(_, company), value: _.id })),
      validations: {
        required: v => v != null,
      },
    },
    debitSegmentId: {
      label: '借方セグメント',
      type: 'select',
      options: consolidationSegments.map(_ => ({ label: _.name, value: _.id })),
    },
    debitIsIntersegment: {
      label: '借方セグメント間',
      type: 'boolean',
      initialValue: false,
    },
    debitChangeType: {
      label: '借方増減種別',
      type: 'select',
      options: changeTypeOptions,
    },
    creditCompanyId: {
      label: '貸方会社',
      type: 'select',
      options: companies.map(_ => ({ label: _.display_name, value: _.id })),
      validations: {
        required: v => v != null,
      },
    },
    creditItemId: {
      label: '貸方科目',
      type: 'select',
      options: consolidationAccountItems.map(_ => ({ label: optionLabel(_, company), value: _.id })),
      validations: {
        required: v => v != null,
      },
    },
    creditSegmentId: {
      label: '貸方セグメント',
      type: 'select',
      options: consolidationSegments.map(_ => ({ label: _.name, value: _.id })),
    },
    creditIsIntersegment: {
      label: '貸方セグメント間',
      type: 'boolean',
      initialValue: false,
    },
    creditChangeType: {
      label: '貸方増減種別',
      type: 'select',
      options: changeTypeOptions,
    },
  };
};

exports.fields = fields;
exports.inheritTypes = inheritTypes;
exports.roundingMethods = roundingMethods;
